import { makeStyles } from "@material-ui/core";
import { color } from "../../assets/const/color";

export const useStyles = makeStyles(() => ({
  error: {
    color: "red",
    fontSize: "12px",
  },
  login: {
    height: "100vh",
    "& .MuiInputBase-root": {
      borderRadius: "50px",
      fontFamily: "inter !important",
    },
    "& .MuiButton-root:hover": {
      background: `${color.lightGreen} !important`,
      color: `${color.white} !important`,
    },
    "& .MuiCheckbox-colorPrimary.Mui-checked": {
      color: `${color.lightGreen} !important`,
      borderRadius: "50px !important",
    },
  },
  login_left: {
    position: "relative",
    background: "#0B3B4B",
    height: "100%",
    width: "100%",
    "& img": {
      objectFit: "container",
      width: "100%",
      height: "100%",
    },
  },
  logo_container: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
  login_right: {
    height: "100%",
    width: "100%",
  },
  sign_in: {
    fontWeight: "700 !important",
    fontSize: "40px !important",
    color: color.black,
    fontFamily: "inter !important",
  },
  input_label: {
    fontFamily: "inter !important",
    fontSize: "18px !important",
    color: "#222222",
  },
  submit_btn: {
    textTransform: "capitalize !important",
    fontFamily: "inter !important",
    color: `${color.white} !important`,
    background: `${color.lightGreen} !important`,
  },
  backBTN: {
    fontFamily: "inter !important",
    fontSize: "14px !important",
    color: "#222222",
    cursor: "pointer",
  },
}));
